// extracted by mini-css-extract-plugin
module.exports = {"checkoutSubsection":"checkoutReviewPage_checkoutSubsection__iv6yc","stickySentinel":"checkoutReviewPage_stickySentinel__A5r_G"};